import { render, staticRenderFns } from "./content-item.vue?vue&type=template&id=581c974f&scoped=true&"
import script from "./content-item.vue?vue&type=script&lang=ts&"
export * from "./content-item.vue?vue&type=script&lang=ts&"
import style0 from "./content-item.vue?vue&type=style&index=0&id=581c974f&lang=scss&scoped=true&"
import style1 from "./content-item.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c974f",
  null
  
)

export default component.exports